import { useEffect, useState } from "react";
import { Download, Trash2, Mail } from "lucide-react";
import { adminApi, getToken, API } from "../../lib/api";
import { toast } from "sonner";

export default function AdminNewsletter() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await adminApi.get("/newsletter");
      setList(r.data);
    } catch { toast.error("Failed to load subscribers"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const downloadCsv = async () => {
    try {
      const res = await fetch(`${API}/newsletter/export.csv`, { headers: { "X-Admin-Token": getToken() } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `voyage-luxe-newsletter-${new Date().toISOString().slice(0,10)}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
      toast.success("CSV downloaded");
    } catch { toast.error("Download failed"); }
  };

  const remove = async (s) => {
    if (!window.confirm(`Remove ${s.email} from the newsletter?`)) return;
    try {
      await adminApi.delete(`/newsletter/${s.id}`);
      setList((l) => l.filter((x) => x.id !== s.id));
      toast.success("Removed");
    } catch { toast.error("Failed to remove"); }
  };

  return (
    <div className="space-y-8" data-testid="admin-newsletter-page">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <div className="eyebrow mb-3">Newsletter</div>
          <h1 className="font-serif text-4xl md:text-5xl">Subscribers <span className="text-accent">· {list.length}</span></h1>
        </div>
        <button onClick={downloadCsv} disabled={list.length === 0} data-testid="newsletter-export-csv" className="inline-flex items-center gap-2 px-6 py-3 bg-foreground text-background hover:bg-accent hover:text-accent-foreground transition-colors uppercase text-[11px] tracking-[0.25em] disabled:opacity-40">
          <Download size={14} strokeWidth={1.5} /> Export CSV
        </button>
      </div>

      {loading ? (
        <div className="text-foreground/50 text-center py-20">Loading…</div>
      ) : list.length === 0 ? (
        <div className="border border-border p-16 text-center text-foreground/60">No subscribers yet.</div>
      ) : (
        <ul className="border border-border">
          {list.map((s, i) => (
            <li key={s.id} className={`flex items-center justify-between gap-4 px-6 py-4 bg-background ${i !== list.length - 1 ? "border-b border-border" : ""}`}>
              <div className="flex items-center gap-3 min-w-0">
                <Mail size={14} strokeWidth={1.25} className="text-accent shrink-0" />
                <a href={`mailto:${s.email}`} className="hover:text-accent truncate">{s.email}</a>
              </div>
              <div className="flex items-center gap-4 shrink-0">
                <span className="text-[11px] text-foreground/55 hidden sm:inline">{new Date(s.subscribed_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}</span>
                <button onClick={() => remove(s)} className="p-2 border border-border hover:border-destructive hover:text-destructive transition-colors" title="Remove">
                  <Trash2 size={12} strokeWidth={1.5} />
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
